export const plants = [
  {
    id: 1,
    name: "Monstera Deliciosa",
    price: 35.99,
    category: "Low Light",
    image: "https://florastore.com/cdn/shop/files/1711701_Atmosphere_04_SQ_MJ_1800x1800.jpg?v=1764599206",
    description: "Known for its unique leaf holes"
  },
  {
    id: 2,
    name: "Snake Plant",
    price: 24.99,
    category: "Low Light",
    image: "https://images.squarespace-cdn.com/content/v1/54fbb611e4b0d7c1e151d22a/1610074066643-OP8HDJUWUH8T5MHN879K/Snake+Plant.jpg?format=1000w",
    description: "Extremely hardy and low-maintenance"
  },
  {
    id: 3,
    name: "Fiddle Leaf Fig",
    price: 45.50,
    category: "Medium Light",
    image: "https://www.beardsanddaisies.co.uk/cdn/shop/files/60-70cm_Fiddle-Leaf_Fig_Hero.jpg?v=1768169591&width=400",
    description: "Popular statement plant"
  },
  {
    id: 4,
    name: "ZZ Plant",
    price: 29.99,
    category: "Low Light",
    image: "https://www.beardsanddaisies.co.uk/cdn/shop/files/BD_ZZ_FAMILY_1000x1100_5d75a883-2430-46b4-831e-402659b3e3b0.jpg?v=1711115361",
    description: "Thrives on neglect"
  },
  {
    id: 5,
    name: "Bird of Paradise",
    price: 55.75,
    category: "Bright Light",
    image: "https://costafarms.com/cdn/shop/articles/White_Bird_of_Paradise_-_Strelitzia_reginae_-_Costa_Farms_520x500_14232d2a-5153-4b8f-9dcf-7cc74d379d49.jpg?v=1736539533",
    description: "Tropical beauty"
  },
  {
    id: 6,
    name: "Peace Lily",
    price: 32.25,
    category: "Medium Light",
    image: "https://www.mydomaine.com/thmb/N3StDx3PyGbF0Pwafv-P9-qiNZU=/900x0/filters:no_upscale():strip_icc()/1566417254329_20190821-1566417255317-b9314f1d9f7a4668a466c5ffb1913a8f.jpg",
    description: "Air-purifying and elegant"
  },
  {
    id: 7,
    name: "Pothos",
    price: 19.99,
    category: "Low Light",
    image: "https://media.houseandgarden.co.uk/photos/64bff5f4d6a55acd0397054e/master/pass/Screenshot%202023-07-25%20at%2017.17.10.png",
    description: "Great for beginners"
  },
  {
    id: 8,
    name: "Rubber Plant",
    price: 42.00,
    category: "Medium Light",
    image: "https://www.houseplant.co.uk/cdn/shop/files/DSC04361_2288326e-97df-4dcc-afed-5987ee132aed.jpg?v=1759229397&width=1946",
    description: "Glossy dark leaves"
  }
];

export const categories = [
  "All",
  "Low Light",
  "Medium Light",
  "Bright Light"
];